module.exports = __webpack_public_path__ + "img/thai-express-menu.2e982aa0.jpg";